<template>
	<div class="">
		<div class="animated fadeIn">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header">
							<el-button-group>
                <el-button icon="el-icon-plus" @click="myModel = true;dlg_title='添加团队'">添加</el-button>
                <el-button icon="el-icon-delete" @click="batchRemove">删除</el-button>
							</el-button-group>
						</div>
						<div class="card-block">
							<!--列表-->
							<el-table stripe :data="users" border highlight-current v-loading="listLoading"
								@selection-change="selsChange" style="width: 100%;">
								<el-table-column type="selection">
								</el-table-column>
								<el-table-column prop="fullName" label="名称">
								</el-table-column>
								<el-table-column prop="contact" label="联系人">
								</el-table-column>
								<el-table-column prop="city" label="城市">
								</el-table-column>
								<el-table-column prop="email" label="邮箱">
								</el-table-column>
								<el-table-column label="启用／停用" width="200px">
									<template slot-scope="scope">
										<el-button-group>
											<el-button v-if="scope.row.isvalid=='1'" size="mini"
												@click="activeCustomer(scope.row,false)">停用
											</el-button>
											<el-button type="primary" v-if="scope.row.isvalid=='0'" size="mini"
												@click="activeCustomer(scope.row,true)">启用
											</el-button>
											<el-button @click="handleEdit(scope.$index, scope.row)" size="mini">编辑
											</el-button>
											<el-button @click="handleEdit(scope.$index, scope.row)" size="mini">查看
											</el-button>
										</el-button-group>
									</template>
								</el-table-column>
							</el-table>
							<!--分页-->
							<el-col :span="24" class="toolbar">
								<el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
									:page-size="page.size" :total="page.total+1" style="float:right;">
								</el-pagination>
							</el-col>
						</div>
					</div>
				</div>
				<!--/.col-->
			</div>
			<!--/.row-->
		</div>
		<el-dialog title="添加团队" :visible.sync="myModel" :close-on-click-modal="false" width="750px">
			<el-form label-width="100px" ref="addForm" :rules="rules" :model="addForm">
				<el-form-item label="名称" prop="name">
					<el-input v-model="addForm.name" style="width:300px"></el-input>
				</el-form-item>
				<el-form-item label="全称">
					<el-input v-model="addForm.fullName" style="width:500px"></el-input>
				</el-form-item>
				<el-form-item label="ukey">
					<el-input v-model="addForm.user_key" style="width:300px"></el-input>
				</el-form-item>
        <el-form-item label="模块">
          <el-checkbox-group v-model="addForm.moduleList">
            <el-checkbox v-for="item in modules" :key="item.value" :label="item.value">
              {{item.label}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
				<el-form-item label="省份">
					<el-select v-model="addForm.province" placeholder="请选择省份" v-on:change="getProv($event)">
						<el-option v-for="item in provs" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<label style="width: 80px;padding-left: 40px;">城市</label>
					<el-select v-model="addForm.city" placeholder="请选择城市" @click="alert()"
						v-on:change="getCity($event)">
						<el-option v-for="item in citys" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地址">
					<el-input v-model="addForm.address" style="width:500px"></el-input>
				</el-form-item>
				<el-form-item label="邮编">
					<el-input v-model="addForm.post_code" style="width:300px"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contact">
					<el-input v-model="addForm.contact" style="width:300px"></el-input>
				</el-form-item>
				<el-form-item label="联系人邮箱">
					<el-input v-model="addForm.email" style="width:300px"></el-input>
				</el-form-item>
				<el-form-item label="联系人电话">
					<el-input v-model="addForm.phone" style="width:300px"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click.native="addSubmit" :loading="addLoading" type="primary">提交</el-button>
					<el-button @click.native="myModel = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import api from '../../api/rest'
  import util from "../../api/util";
	export default {
		name: 'tables',
		data() {
			return {
        // 新增界面数据
        provs: util.setting.getProvs(),
        modules: util.setting.getModules(),
        rules: util.setting.getRules(),
        dlg_title: '添加客户',
        selectProv: '',
        selectCity: '',
        citys: [],
        addForm: {
          isvalid: true,
          moduleList: ['hr','crm'],
        },
				users: [],
				page: {
					total: 0,
					index: 0,
					size: 10
				},
				listLoading: false,
				sels: [], // 列表选中列
				addLoading: false,
				myModel: false,
        collapse: api.storage.get('isCollapse'),
      }
    },
    methods: {
      shrinkMenu() {
        this.collapse = !this.collapse;
        api.storage.set('isCollapse', this.collapse);
      },
			getProv: function(prov) {
				let tempCity = []
				this.citys = []
				if (this.dlg_title === '添加客户') {
					this.addForm.city = null
					// this.updateForm.city = null
				}
				let allCity = util.setting.getCity()
				for (var val of allCity) {
					if (prov === val.prov) {
						tempCity.push({
							label: val.label,
							value: val.label
						})
					}
				}
				this.citys = tempCity
			},
			getCity: function(city) {},
			handleCurrentChange(val) {
				this.page.index = val - 1
				this.getGroups()
			},
			// 获取列表
			getGroups() {
				// name: this.filters.name
				this.listLoading = true
				api.admin.groupList(this.page.index, this.page.size).then((res) => {
					this.page.total = res.totalElements
					this.users = res.content
					this.listLoading = false
				}).catch((res) => {
					this.listLoading = false
					api.handError.action(this, res)
				})
			},
			// 启用／停用
			activeCustomer: function(row, enabled) {
				let data = row
				if (enabled === true) {
					data.isvalid = 1
				} else {
					data.isvalid = 0
				}
				api.admin.enabledGroup(data).then((res) => {
					this.$message({
						title: res.title,
						message: res.message,
						type: res.status
					})
					this.getGroups()
				}).catch((res) => {
					if (enabled === true) {
						data.isvalid = 0
					} else {
						data.isvalid = 1
					}
					api.handError.action(this, res)
				})
			},
			// 新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.addLoading = true
            let para = Object.assign({}, this.addForm)
            api.admin.groupAdd(para).then((res) => {
              this.addLoading = false
              this.$message({
                title: res.title,
                message: res.message,
                type: res.status
              })
              this.myModel = false
              api.storage.set('moduleList', para.moduleList)
              this.getGroups()
            }).catch((res) => {
              this.addLoading = false
              api.handError.action(this, res)
            })
          }
        })
      },
      // 编辑
      handleEdit: function (index, row) {
        this.myModel = true
        if (row.moduleList == undefined) {
          row.moduleList = []
        }
        this.dlg_title = '编辑'
        this.addForm = Object.assign({}, row)
      },
			// 批量删除
			batchRemove: function() {
				if (this.sels.length === 0) {
					this.$message({
						title: '请选择',
						message: '请选择',
						type: 'msg'
					})
					return
				}
				var models = this.sels.map(item => item)
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true

					let para = models
					api.admin.groupRemove(para).then((res) => {
						this.listLoading = false

						this.$message({
							title: res.title,
							message: res.message,
							type: res.status
						})
						this.getGroups()
					}).catch((res) => {
						this.listLoading = false
						api.handError.action(this, res)
					})
				})
			},
			selsChange: function(sels) {
				this.sels = sels
			}
		},
		mounted() {
			// this.$router.push({ path: '/login' })
			this.getGroups()
		}
	}
</script>



// WEBPACK FOOTER //
// Group.vue?3d9ebef8